import { useEffect } from 'react';

export default function handleClickOutside(
  ref,
  { setShowBox },
  handleRef = null
) {
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        if (
          handleRef &&
          handleRef.current &&
          handleRef.current.contains(e.target)
        )
          setShowBox(true);
        else setShowBox(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}
